// utils/presetUtils.ts
import { UserFeedPreference, WeightsDto } from '../../../apis/user-preferences';

/**
 * Converts UserFeedPreference to WeightsDto format
 */
export const presetToWeights = (preset: UserFeedPreference): WeightsDto => {
  return {
    educationalValueWeight: preset.educationalValueWeight,
    lightheartednessWeight: preset.lightheartednessWeight,
    contentQualityWeight: preset.contentQualityWeight,
    contentTrustworthinessWeight: preset.contentTrustworthinessWeight,
    clickbaitWeight: preset.clickbaitWeight,
    integrityWeight: preset.integrityWeight,
    // politicalBiasWeight: preset.politicalBiasWeight,
    civilityWeight: preset.civilityWeight,
    recencyWeight: preset.recencyWeight,
    perspectiveDiversityWeight: preset.perspectiveDiversityWeight,
    originalityWeight: preset.originalityWeight,
    sentimentWeight: preset.sentimentWeight,
    embeddingSimilarityWeight: preset.embeddingSimilarityWeight
  };
};

/**
 * Creates default weights that promote healthy discourse and reduce divisive content.
 * These values reflect our platform's commitment to civility, integrity, and constructive dialogue.
 */
export const createDefaultWeights = (): WeightsDto => {
  return {
    educationalValueWeight: 1.0, // Keep neutral - don't punish natural writing
    lightheartednessWeight: 1.0, // Keep neutral
    contentQualityWeight: 1.0, // Keep neutral - don't punish natural writing
    contentTrustworthinessWeight: 1.0, // Keep neutral for now
    clickbaitWeight: 1.3, // Actively reduce clickbait content
    integrityWeight: 1.2, // Promote good-faith arguments
    civilityWeight: 1.3, // Actively promote civil discourse
    recencyWeight: 1.0, // Keep neutral (often overridden)
    perspectiveDiversityWeight: 1.0, // Keep neutral
    originalityWeight: 1.0, // Keep neutral
    sentimentWeight: 1.0, // Keep neutral
    embeddingSimilarityWeight: 1.0 // Frontend default (backend scales this)
  };
};
